import axios from "axios";

export const adminApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const STATUS = {
  nuova: { label: "Da contattare", cls: "bg-[#F3E6D8] text-[#8A5A2B]" },
  fissata: { label: "Visita fissata", cls: "bg-[#DCE8DA] text-[#1B3B28]" },
  conclusa: { label: "Visita svolta", cls: "bg-[#ECEBE4] text-[#526356]" },
};

export const CHECKIN = {
  bene: { label: "Sto bene", cls: "bg-[#DCE8DA] text-[#1B3B28]" },
  fastidio: { label: "Un po' di fastidio", cls: "bg-[#F3E6D8] text-[#8A5A2B]" },
  aiuto: { label: "Ha bisogno di aiuto", cls: "bg-[#F4DCD6] text-[#9A4B3C]" },
};

export const EMAIL_KINDS = {
  notifica_staff: "Notifica allo staff",
  conferma_richiesta: "Conferma richiesta",
  conferma_visita: "Conferma visita",
  visita_spostata: "Visita spostata",
  promemoria: "Promemoria + respiro",
  consigli: "Consigli post-seduta",
  check_in: "Come ti senti?",
  avviso_check_in: "Avviso check-in allo staff",
  richiesta_recensione: "Richiesta recensione Google",
  richiamo: "Richiamo controllo",
  newsletter: "Newsletter",
  notifica_preventivo: "Nuovo preventivo allo staff",
  conferma_preventivo: "Conferma preventivo ricevuto",
};

export const fmtDate = (iso, opts = { day: "numeric", month: "short" }) =>
  iso ? new Date(iso.length === 10 ? `${iso}T00:00` : iso).toLocaleDateString("it-IT", opts) : "—";

export const fmtDateTime = (iso) =>
  new Date(iso).toLocaleString("it-IT", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" });

export const Badge = ({ cls, children, testid }) => (
  <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-medium whitespace-nowrap ${cls}`} data-testid={testid}>{children}</span>
);
